export enum PurchaseOrderStatuses {
  allocated = 'ALLOCATED',
  authorized = 'AUTHORIZED',
  cancelled = 'CANCELLED',
  complete = 'COMPLETE',
  confirmed = 'CONFIRMED',
  emailed = 'EMAILED',
  invoiced = 'INVOICED',
  pending = 'PENDING',
  printed = 'PRINTED',
  rejected = 'REJECTED',
}
